// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1VNhM","content":"styles_content__Svvtx","checkbox":"styles_checkbox__387tr","checkboxLabel":"styles_checkboxLabel__37WH0"};